export const IG_HANDLE = "hellovintora";
export const IG_PROFILE_URL = `https://www.instagram.com/${IG_HANDLE}`;
export const IG_DM_URL = `https://ig.me/m/${IG_HANDLE}`;
export const VINTED_URL = "https://www.vinted.de/member/3193810651-hellovintora";
export const TIKTOK_URL = "https://www.tiktok.com/@vintora8";
export const CATEGORIES = ["Tracksuits", "Hoodies", "Sweater", "T-Shirts", "Sneaker", "Hosen"];
export const CONDITIONS = ["neu", "wie_neu", "vinted"];
export const STATUSES = ["available", "reserved", "sold"];

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function imgSrc(url) {
  if (!url) return "";
  if (url.startsWith("/api")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}
